export class ApiError extends Error {
  code: string;
  status: number;
  body?: Record<string, unknown>;

  constructor(
    code: string,
    message: string,
    status: number,
    body?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.body = body;
  }
}
